import { emailRecipientTypeConstants } from '../constants/emailRecipientTypes.constants'

export const getEmailRecipientTypeId = distribution => {
    return emailRecipientTypeConstants[distribution] || null
}
